/*
 * @Author: Teemo Ding
 * @Date: 2021-12-01 11:57:07
 * @LastEditTime: 2021-12-10 11:33:53
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/customer/list.ts
 */
import {
  get,
  post, // remove
} from 'src/tools/server';

const getFilterOptions = (uuid: string) => {
  return get<any>(`/portal/customer/${uuid}/filterOptions`, {});
};

const listSearch = (uuid: string, body: any) => {
  return post(`/portal/customer/${uuid}/search`, body, {});
};

const addTags = (body: any) => {
  return post(`/portal/customer/addTags`, body, {});
};

const subscriberListPage = (start, count, body) => {
  return post(`/portal/subscriber/page/${start}/${count}`, body, {});
};

const subscriberListSearch = (start, count, body) => {
  return post(`/portal/subscriber/search/${start}/${count}`, body, {});
};

const customerExport = (uuid, body) => {
  return post(`/portal/customer/${uuid}/export`, body, {
    returnWholeData: true,
    responseType: 'arraybuffer',
  });
};

const subscriberExport = (body) => {
  return post(`/portal/subscriber/export`, body, {
    responseType: 'arraybuffer',
    returnWholeData: true,
  });
};

export {
  getFilterOptions,
  listSearch,
  subscriberListPage,
  subscriberListSearch,
  addTags,
  customerExport,
  subscriberExport,
};
